const rangeArray = (length: number) => Array.from({ length }, (_, i) => i);

export default rangeArray;
